// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';

export const updateClosingAccountListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT_FILTER_BY
});

export const updateClosingAccountListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT_SORT_BY
});

export const updateClosingAccountListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/closing-account-search-filters.js